import { gql } from '@zenbusiness/application-commons-graphql';

export const MARKETING_TOOLS_HOME_QUERY = gql`
  query MarketingToolsHomeQuery($businessEntityUuid: UUID!) {
    accountInfo {
      accountUuid
      pricing(businessEntityUuid: $businessEntityUuid) {
        service
        amount
        interval
      }
    }
    businessEntity: businessEntityLegacy(businessEntityUuid: $businessEntityUuid) {
      businessEntityUuid
      businessEntityName
      businessEntityType
    }
    orderTasksLegacy(businessEntityUuid: $businessEntityUuid) {
      orderTasksLegacy {
        orderTaskUuid
        orderTaskStatus
        orderTaskType
      }
    }
    vanityPricing {
      servicePricingUuid
      amount
      service
    }
    websites(businessEntityUuid: $businessEntityUuid) {
      websites {
        websiteUuid
        deleted
        active
      }
    }
  }
`;

export const GET_LOGO_USERS_QUERY = gql`
  query GetLogoUsersCount{
    getLogoUsersCount {
      logoUsersCount
    }
  }
`;

export const GET_LOGO_BRANDS_QUERY = gql`
  query GetLogoBrandsCount($businessEntityUuid: UUID!) {
    getLogoBrandsCount(businessEntityUuid: $businessEntityUuid) {
      brandsCount
    }
  }
`;

// TODO: Optimize graphql queries to avoid fetching same data on multiple queries
export const GET_WEBSITES_DATA = gql`
  query WebsitesDataQuery($businessEntityUuid: UUID!) {
    domains(businessEntityUuid: $businessEntityUuid) {
      domains {
        websiteConnectionStatus
        deleted
      }
    }
    orderTasksLegacy(businessEntityUuid: $businessEntityUuid) {
      orderTasksLegacy {
        orderTaskUuid
        orderTaskType
        orderTaskStatus
        orderTaskJurisdiction
        orderTaskStatusUpdates {
          statusUpdatedFrom
          statusUpdatedTo
          subStatusUpdatedTo
          subStatusUpdatedFrom
          createdDatetime
        }
        orderTaskData {
          ...on DomainNameData {
            skip
          }
        }
      }
    }
    accountInfo {
      accountUuid
      pricing(businessEntityUuid: $businessEntityUuid) {
        service
        amount
        interval
      }
    }
  }
`;
